var MISSEVAN_BILI_PREFIX_URL = 'https://maoer.bilibili.com';
var MISSEVAN_ANDROID_PACKAGE_NAME = 'cn.missevan';

export { MISSEVAN_ANDROID_PACKAGE_NAME, MISSEVAN_BILI_PREFIX_URL };
